import { getV1 } from '@/common/utils/ajax'
import { mapHouseDetail, mapHouseItem, handleBusinessHouses } from '@/common/utils/map_view_data'

const handleParams = (data) => {
    Object.keys(data).forEach((key) => {
        if (!data[key]) {
            delete data[key]
        }
    })
}

const list = (data) => {
    handleParams(data)
    return getV1('business_buildings', data).then((data) => {
        data.items = data.items.map(mapHouseItem)
        handleBusinessHouses(data.items)
        return data
    })
}

const get = (id, params) => {
    return getV1(`business_buildings/${id}`, params).then(mapHouseDetail)
}

export default {
    list,
    get
}
